import {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';

import ModalTypes from '../../../enums/app/modalTypes';
import {makeSelectVisibleGlobalModal} from '../../../state/selectors/modal';

const usePageContentInert = () => {
    const ref = useRef(null);
    const isVisibleQSGPopup = useSelector(makeSelectVisibleGlobalModal(ModalTypes.QUICK_START_GUIDE_POPUP));

    useEffect(() => {
        const el = ref.current;

        if (isVisibleQSGPopup) {
            el.setAttribute('inert', '');
        } else {
            el.removeAttribute('inert');
        }
    }, [isVisibleQSGPopup]);

    return ref;
};

export default usePageContentInert;
